import static_animations from "../assets/animations/animationManifest.json";

export const ANIMATION_TYPES = {
    LOADING: "loading",
}
export const getAnimationData = (animationId) => {
    const animationData = static_animations?.find(item => item.id === animationId);
    return animationData;
}
